// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-q_fN","galleryThumbnail_active":"c-q_fO","galleryThumbnail__image":"c-q_fP"};